module.exports = __webpack_public_path__ + "img/no_data.a75723b3.png";